import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

interface ReactivateCashierInput {
  cashierId: string
}

export interface ReactivateCashierResult {
  pin: string
}

async function reactivateCashier(input: ReactivateCashierInput): Promise<ReactivateCashierResult> {
  const { data, error } = await supabase.functions.invoke<ReactivateCashierResult>('reactivate-cashier', {
    body: { cashierId: input.cashierId },
  })
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  if (!data) {
    const failure = new Error('No data returned from reactivate-cashier')
    reportUnexpectedError(failure)
    throw failure
  }
  return data
}

export function useReactivateCashier() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: reactivateCashier,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['cashiers'] }),
  })
}